import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Conditional from '../../common/conditional';
import CustomUTMSummaryReadingItem from './customUTMSummaryReadingItem';
import CustomUTMSummaryEditReadingItem from './customUTMSummaryEditReadingItem';
import Form from '../../common/form';
import ListGroup from '../../blocks/list-group';

import * as models from '../../../utils/models';
import * as toastService from '../../../services/toastService';

class CustomUTMSummaryReadingsForm extends Form {
	state = {
		data: { readings: [] },
		errors: {},
		loading: false,
		progress: 0,
		readingToEdit: null,
	};

	schema = {
		readings: Joi.array().min(1).items(
			Joi.object({
				srNo: Joi.number().required().label('Sr. No'),
				thickness: Joi.number().min(0).required(),
				option: Joi.string().required(),
				label: Joi.string().required(),
			})
		).required().label('Thickness Readings'),
	};

	static propTypes = {
		options: PropTypes.array,
		initialReadings: PropTypes.array,
		onSave: PropTypes.func,
	};

	componentDidMount(): void {
		if (this.props.initialReadings) {
			this.setState({ data: { readings: this.props.initialReadings }});
		}
	}
	

	onAddItem = (newReading: models.UTMReadingItem) => {
		this.setState({ data: { readings: [...this.state.data.readings, { ...newReading, srNo: this.state.data.readings.length + 1} ]  } });
	};

	onDeleteItem = (readingToDelete: models.SelectOption): void => {
		const readings = this.state.data.readings.filter((reading: models.UTMReadingItem) => reading.srNo !== readingToDelete.id);
		this.setState({ data: { readings } });
	};

	onEditItem = (readingToEdit: models.SelectOption) => {
		const readingMatch = this.state.data.readings.find((reading: models.UTMReadingItem) => reading.srNo === readingToEdit.id);
		this.setState({ readingToEdit: readingMatch } as any);
	};

	onReadingItemEdit = (updatedReading: models.UTMReadingItem) => {
		const readings = this.state.data.readings.map((reading: models.UTMReadingItem) => reading.srNo === updatedReading.srNo ? updatedReading : reading);
		this.setState({ data: { ...this.state.data, readings}, readingToEdit: null } as any);
	};

	renderThicknessReadings = (): models.SelectOption[] => {
		return this.state.data.readings.map((reading: models.UTMReadingItem) => ({ id: reading.srNo, name: reading.label }));
	}

	doSubmit = (): void => {
		this.props.onSave(this.state.data.readings);
		toastService.success('Readings Saved!');
	};

	render() {
		return (
			<React.Fragment>
				{this.state.readingToEdit ? (
					<CustomUTMSummaryEditReadingItem 
						options={this.props.options}
						onEdit={this.onReadingItemEdit}
						onCancelEdit={() => this.setState({ readingToEdit: null } as any)}
						readings={this.state.data.readings}
						reading={this.state.readingToEdit}
					/>
				) : (
					<>
						<CustomUTMSummaryReadingItem 
							options={this.props.options}
							onAdd={this.onAddItem} 
							readings={this.state.data.readings} 
						/>

						<div className="my-4 divider"></div>

						<ListGroup 
							onRemove={this.onDeleteItem} 
							data={this.renderThicknessReadings()} 
							onEditItem={this.onEditItem} 
						/>

						<Conditional isVisible={this.state.data.readings.length > 0}>
							<form onSubmit={this.handleSubmit}>
								<div className="my-4 divider"></div>

								<div className="d-flex justify-content-end">
									{this.renderButton('Finish and Save Readings')}
								</div>
							</form>
						</Conditional>
					</>
				)}


				
			</React.Fragment>
		);
	}
}

export default CustomUTMSummaryReadingsForm;
